import { useEffect, useRef } from "react";
import Radar from "radar-sdk-js";
import "radar-sdk-js/dist/radar.css";

import '../../index.css'
import classes from './MapRadar.module.css'
import { useDispatch, useSelector } from "react-redux";

import marblePin from '../../assets/map/marble-pin.png'
import gacPin from '../../assets/map/gac-pin.png'
import cncPin from '../../assets/map/cnc-pin.png'

import cnclogo from '../../assets/map/cnc-logo.svg'
import phone from '../../assets/map/Phone.png'
import clock from '../../assets/map/Clock.png'
import { getDayOfTheWeek } from "../../scripts/helpers";


import RadarMapGAClocation from "../../icons/radarMapGAClocation";
import { locationActions } from "../../store/location";

function returnPinLocation(location) {
    if (location) {
        if (location.data && location.data.attributes && location.data.attributes.includes("MSC")) {            
            return marblePin
        } else if (location.data && location.data.attributes && (location.data.attributes.findIndex(element => element.includes("CNC")) >= 0)) {            
            return cncPin
        } else {
            return gacPin
        }
    } 
}

function returnElement(location) {
    const el = document.createElement('div');
        el.className = 'marker';

        if (location) {
            if (location.data && location.data.attributes && location.data.attributes.includes("MSC")) {            
                el.innerHTML = `<svg width="48" height="65" viewBox="0 0 48 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" rx="24" fill="#584646"/>
                    <path d="M24 64.5L19.6699 28.875L28.3301 28.875L24 64.5Z" fill="#584646"/>
                    <path d="M23.7819 21.1766C25.8175 21.1766 27.8531 21.1815 29.8938 21.1766C30.6326 21.1766 31.2408 20.7369 31.4871 20.0774C31.7233 19.4374 31.6027 18.5776 30.9945 18.3089C30.13 17.9229 30.2506 17.3416 30.3511 16.6869C30.3511 16.6723 30.3511 16.6576 30.3511 16.6381C30.5421 11.7869 25.3249 8.51367 20.8616 10.6828C18.2731 11.9383 16.8658 14.6155 17.3131 17.41C17.3483 17.6347 17.4136 17.835 17.0869 17.9767C16.2224 18.3577 15.8555 19.071 16.0515 19.8771C16.2526 20.7125 16.8959 21.1766 17.871 21.1766C19.8363 21.1766 21.8066 21.1766 23.7819 21.1766Z" fill="white"/>
                    <path d="M23.8271 25.5099C22.7414 25.5099 21.6608 25.5099 20.5751 25.5099C19.2181 25.5099 18.7255 26.1743 19.1527 27.425C20.4847 31.3431 21.8166 35.2612 23.1737 39.1695C23.2792 39.4773 23.5808 39.7264 23.7869 40C23.993 39.7215 24.2895 39.4724 24.3951 39.1646C25.7622 35.2221 27.1092 31.2747 28.4512 27.3273C28.8282 26.2281 28.3055 25.5197 27.1193 25.5099C26.0286 25.5002 24.9278 25.5099 23.8271 25.5099Z" fill="white"/>
                </svg>`
            } else if (location.data && location.data.attributes && (location.data.attributes.findIndex(element => element.includes("CNC")) >= 0)) {            
                el.innerHTML = `<svg width="48" height="65" viewBox="0 0 48 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Location Pin / Cobrand">
                <rect width="48" height="48" rx="24" fill="#584646"/>
                <path id="Polygon 1" d="M24 64.5L19.6699 28.875L28.3301 28.875L24 64.5Z" fill="#584646"/>
                <g id="Vector">
                <path d="M19.825 15.0788C20.1047 15.1549 20.3911 15.2144 20.6641 15.307C20.8798 15.3798 21.0954 15.4725 21.2841 15.5982C21.5436 15.7702 21.547 15.9224 21.4088 16.1903C21.1763 16.6469 20.9067 17.0968 20.7551 17.5798C20.4956 18.3936 20.6944 19.1809 21.1022 19.912C21.2606 20.1998 21.5167 20.3818 21.8334 20.5009C22.2917 20.6729 22.6254 20.9773 22.75 21.4702C22.7703 21.5496 22.8073 21.629 22.8579 21.6918C23.0702 21.9399 23.2825 22.188 23.5083 22.4229C23.9464 22.8795 24.5192 23.0647 25.1326 23.1507C25.4055 23.1871 25.6852 23.2037 25.9582 23.2367C26.5715 23.3128 26.8815 23.6701 26.895 24.2689C26.9051 24.6229 26.9355 24.9768 26.9826 25.3275C27.0332 25.7212 26.9692 26.1016 26.8445 26.4655C26.6895 26.9121 26.6288 27.3554 26.7131 27.8219C26.7872 28.2288 26.6726 28.5894 26.4704 28.9665C26.0862 29.6877 25.6279 30.3526 25.082 30.9613C24.3002 31.8347 23.3836 32.5426 22.3221 33.0554C22.039 33.191 21.6818 33.1943 21.3549 33.2208C20.4046 33.2969 19.4442 33.3035 18.5242 33.588C18.2007 33.6873 17.8772 33.7832 17.5604 33.9023C17.0246 34.1041 16.4921 34.1173 15.9327 34.0048C14.605 33.7369 13.3682 33.2605 12.2562 32.4996C12.1652 32.4368 12.0809 32.321 12.0607 32.2184C11.9967 31.8975 11.9495 31.5667 11.9192 31.2359C11.8788 30.8257 11.744 30.6801 11.3463 30.5445C10.7802 30.3559 10.2241 30.1343 9.6681 29.9159C9.6007 29.8895 9.55015 29.8035 9.50634 29.7373C8.6268 28.3776 8.16176 27.0047 8 25.301C8.08762 25.2713 8.18197 25.2448 8.26959 25.2018C8.47179 25.1025 8.57288 24.9338 8.5931 24.7155C8.71105 23.5444 8.829 22.37 8.96042 21.1989C9.00423 20.8085 9.08511 20.4248 9.15588 20.0377C9.16936 19.965 9.19631 19.8922 9.23338 19.826C10.4533 17.7617 12.1719 16.2763 14.4769 15.4724C15.5182 15.1086 16.5831 15.0854 17.6649 15.274C18.0187 15.3368 18.3827 15.3567 18.7432 15.3997C18.9252 15.4195 19.0701 15.3765 19.1881 15.2243C19.2386 15.1582 19.333 15.1218 19.4071 15.0755C19.5453 15.0788 19.6834 15.0788 19.825 15.0788ZM18.0895 23.1573C17.4323 23.3658 16.7921 23.5709 16.1316 23.7826C16.3472 24.4343 16.5562 25.0662 16.7685 25.7046C17.4357 25.4896 18.076 25.2878 18.7264 25.0794C18.5107 24.4244 18.3018 23.7958 18.0895 23.1573ZM10.8004 27.3653C11.4676 27.1536 12.1113 26.9485 12.7583 26.7401C12.5393 26.0851 12.3303 25.4598 12.118 24.818C11.4541 25.0298 10.8139 25.2349 10.1601 25.4433C10.3791 26.0884 10.5847 26.7169 10.8004 27.3653ZM20.007 28.2089C19.7643 28.7349 19.5352 29.2345 19.3026 29.7406C19.8351 29.9788 20.3439 30.2038 20.8595 30.432C21.1022 29.9093 21.3313 29.4131 21.5638 28.9036C21.0348 28.6654 20.5327 28.4438 20.007 28.2089ZM14.9083 21.0963C15.3565 20.3454 15.7845 19.6275 16.2091 18.9196C15.3767 18.9196 14.5679 18.9196 13.712 18.9196C14.1197 19.6606 14.5039 20.3586 14.9083 21.0963ZM22.0862 24.4508C22.3153 25.172 22.531 25.8535 22.7568 26.5681C23.2825 25.9958 23.7711 25.4631 24.28 24.9107C23.5251 24.7519 22.8242 24.603 22.0862 24.4508ZM14.8005 27.2562C14.6893 28.0005 14.5882 28.7018 14.4803 29.4363C15.2048 29.165 15.8788 28.9103 16.5865 28.6423C15.9799 28.1725 15.4104 27.7292 14.8005 27.2562Z" fill="white"/>
                <path d="M33.7888 21.6646C35.1456 21.6646 36.5025 21.668 37.8627 21.6646C38.3552 21.6646 38.7606 21.3631 38.9247 20.9108C39.0822 20.4719 39.0018 19.8823 38.5964 19.698C38.0202 19.4333 38.1006 19.0347 38.1676 18.5857C38.1676 18.5757 38.1676 18.5656 38.1676 18.5522C38.2949 15.2254 34.8173 12.9807 31.8423 14.4682C30.1169 15.3293 29.1788 17.1652 29.477 19.0816C29.5004 19.2357 29.544 19.373 29.3262 19.4702C28.75 19.7315 28.5054 20.2206 28.636 20.7734C28.7701 21.3463 29.1989 21.6646 29.8488 21.6646C31.1588 21.6646 32.4721 21.6646 33.7888 21.6646Z" fill="white"/>
                <path d="M33.8189 24.6363C33.0953 24.6363 32.375 24.6363 31.6513 24.6363C30.7467 24.6363 30.4184 25.0919 30.7032 25.9496C31.591 28.6365 32.4788 31.3234 33.3834 34.0037C33.4538 34.2147 33.6548 34.3856 33.7921 34.5732C33.9295 34.3822 34.1272 34.2114 34.1975 34.0003C35.1088 31.2966 36.0067 28.5896 36.9012 25.8826C37.1525 25.1288 36.804 24.643 36.0134 24.6363C35.2864 24.6296 34.5526 24.6363 33.8189 24.6363Z" fill="white"/>
                </g>
                </g>
                </svg>`
            } else {
                el.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="65" viewBox="0 0 48 65" fill="none">
                    <rect width="48" height="48" rx="24" fill="#584646"/>
                    <path d="M24 64.5L19.6699 28.875L28.3301 28.875L24 64.5Z" fill="#584646"/>
                    <path d="M26.4473 14.0035C26.7418 14.0836 27.0433 14.1463 27.3306 14.2438C27.5576 14.3204 27.7847 14.4179 27.9833 14.5502C28.2564 14.7313 28.26 14.8915 28.1146 15.1735C27.8698 15.6541 27.586 16.1277 27.4264 16.6361C27.1532 17.4927 27.3625 18.3215 27.7918 19.0911C27.9585 19.3941 28.2281 19.5856 28.5615 19.711C29.0439 19.892 29.3951 20.2124 29.5264 20.7313C29.5477 20.8148 29.5867 20.8984 29.6399 20.9646C29.8634 21.2257 30.0868 21.4869 30.3245 21.7342C30.7856 22.2147 31.3887 22.4097 32.0343 22.5003C32.3216 22.5386 32.616 22.556 32.9034 22.5908C33.549 22.6709 33.8753 23.047 33.8895 23.6773C33.9001 24.0499 33.9321 24.4225 33.9817 24.7916C34.0349 25.206 33.9675 25.6065 33.8363 25.9895C33.6731 26.4596 33.6093 26.9263 33.6979 27.4173C33.776 27.8456 33.6554 28.2251 33.4425 28.6221C33.0382 29.3813 32.5557 30.0812 31.9811 30.7219C31.1581 31.6413 30.1933 32.3865 29.0759 32.9262C28.7779 33.069 28.4019 33.0725 28.0578 33.1004C27.0575 33.1804 26.0465 33.1874 25.0781 33.4869C24.7376 33.5914 24.397 33.6923 24.0636 33.8177C23.4996 34.0301 22.9391 34.0441 22.3503 33.9257C20.9526 33.6436 19.6508 33.1421 18.4802 32.3412C18.3844 32.2751 18.2957 32.1532 18.2745 32.0452C18.2071 31.7074 18.1574 31.3592 18.1255 31.011C18.0829 30.5792 17.941 30.426 17.5224 30.2832C16.9265 30.0847 16.3412 29.8514 15.7559 29.6215C15.6849 29.5937 15.6317 29.5031 15.5856 29.4335C14.6598 28.0023 14.1703 26.5571 14 24.7638C14.0922 24.7324 14.1916 24.7046 14.2838 24.6593C14.4966 24.5548 14.603 24.3772 14.6243 24.1474C14.7485 22.9147 14.8726 21.6784 15.011 20.4457C15.0571 20.0348 15.1422 19.6309 15.2167 19.2234C15.2309 19.1468 15.2593 19.0702 15.2983 19.0006C16.5824 16.8276 18.3915 15.2641 20.8178 14.4179C21.9139 14.0348 23.0349 14.0104 24.1735 14.2089C24.546 14.2751 24.9291 14.296 25.3087 14.3413C25.5002 14.3622 25.6528 14.3169 25.7769 14.1567C25.8301 14.0871 25.9294 14.0488 26.0075 14C26.1529 14.0035 26.2984 14.0035 26.4473 14.0035ZM24.6205 22.5072C23.9288 22.7266 23.2548 22.9425 22.5595 23.1654C22.7866 23.8514 23.0065 24.5165 23.23 25.1886C23.9323 24.9622 24.6063 24.7498 25.2909 24.5304C25.0639 23.8409 24.844 23.1793 24.6205 22.5072ZM16.9478 26.9367C17.6501 26.7138 18.3277 26.4979 19.0087 26.2786C18.7782 25.5891 18.5582 24.9309 18.3348 24.2553C17.6359 24.4782 16.962 24.6941 16.2738 24.9135C16.5044 25.5925 16.7208 26.2542 16.9478 26.9367ZM26.6389 27.8247C26.3835 28.3784 26.1423 28.9042 25.8975 29.437C26.458 29.6877 26.9936 29.9245 27.5364 30.1648C27.7918 29.6146 28.033 29.0922 28.2777 28.556C27.7208 28.3052 27.1923 28.0719 26.6389 27.8247ZM21.2719 20.3378C21.7437 19.5473 22.1942 18.7916 22.6411 18.0464C21.765 18.0464 20.9136 18.0464 20.0126 18.0464C20.4418 18.8265 20.8462 19.5612 21.2719 20.3378ZM28.8276 23.8688C29.0688 24.6279 29.2958 25.3453 29.5335 26.0975C30.0868 25.495 30.6012 24.9344 31.1368 24.3528C30.3422 24.1857 29.6044 24.029 28.8276 23.8688ZM21.1584 26.8218C21.0413 27.6053 20.9349 28.3435 20.8214 29.1166C21.584 28.8311 22.2935 28.5629 23.0384 28.2809C22.3999 27.7864 21.8004 27.3198 21.1584 26.8218Z" fill="white"/>
                </svg>`
            }
        } 
        

    return el
}


const MapRadar = ({locations, zoom, center}) => {
    const dispatch = useDispatch()
    const mapRef = useRef(null)
    const markerRef = useRef(null);

    const foundLocations = useSelector(state => state.location.foundLocations)
    const activelocation = useSelector(state => state.location.mapSelectedLocation)  

    useEffect(() => {
        
        Radar.initialize(process.env.REACT_APP_RADAR_MAPS, {});
        const map = Radar.ui.map({
            container: "map",
            style: "radar-default-v1",
            center: center ? center : [-73.9911, 40.7342], // NYC
            zoom: zoom ? zoom : 14,
        });

        mapRef.current = map

        function setHtml(element) {
            if (!element.exempt_store) {
                return `
                    <div class="map-popup-container">
                        <div class="map-popup-header"> 
                            ${element.address.street}<br />
                            ${element.address.city}, ${element.address.state}, ${element.address.zip}
                        </div>
                        
                        <div class="distance_directions">
                            <div class="map-popup-distance">(${element.address.distance} mile${element.address.distance === 1 ? '' : 's'} away)</div>
                            <button class="btn get-directions-btn" onclick="window.open('${element.address.directions}', '_blank')">Get directions</button>
                        </div>

                        <div class="map-popup-row"><img src="${phone}" alt="phone"/> ${element.telephone}</div>
                        <div class="map-popup-row"><img src="${clock}" alt="clock"/> Open until ${element.hours && element.hours.business && element.hours.business[getDayOfTheWeek()] && new Date(element.hours.business[getDayOfTheWeek()]?.end).toLocaleTimeString('en-US', { hour: "2-digit", minute: "2-digit" })}</div>
                        <div class="map-popup-footer">
                            <a href="${'/menu/' + element.slug}" class="btn">Order Now</a>
                        </div>
                    </div>
                `
            } else {
                return `
                    <div class="map-popup-container">
                        <div class="map-popup-header"> 
                            ${element.address.full_address}
                        </div>
                        
                        <div class="distance_directions">
                            <div class="map-popup-distance">(${element.address.distance.toFixed(2)} mile${element.address.distance === 1 ? '' : 's'} away)</div>
                            <button class="btn get-directions-btn" onclick="window.open('${element.address.directions}', '_blank')">Get directions</button>
                        </div>

                        <div class="map-popup-row"><img src="${phone}" alt="phone"/> ${element.telephone}</div>
                        <div class="map-popup-row"><img src="${clock}" alt="clock"/> Open until ${element.hours && element.hours.business && element.hours.business[getDayOfTheWeek()] && element.hours.business[getDayOfTheWeek()]?.end}</div>
                    </div>
                `
            }
        }
        
        if (foundLocations) {
            foundLocations.forEach(element => {
                const marker = Radar.ui.marker({ 
                    // url: returnPinLocation(element),
                    element: returnElement(element),
                    marker_id: element.id,
                    popup: {
                        // text: element.name
                        maxWidth: '325px',
                        anchor: 'bottom',
                        offset: 50,
                        html: setHtml(element)
                    } 
                })
                .setLngLat([element.address.longitude, element.address.latitude]) // default example.
                .addTo(map);

                marker.marker_id = element.id
                // if (activelocation.id === element.id) {
                //     marker.addClassName('marker-active') 
                // }
                
                marker.on('click', (event) => {
                    event.target.addClassName('marker-active')

                    // map zoom on marker's click
                    map.fitToMarkers({
                        center: [element.address.longitude, element.address.latitude],
                        zoom: 16,
                        speed: 2,
                        curve: 1
                    })

                    dispatch(locationActions.setMapSelectedLocation({
                        id: element.id,
                        scroll: true
                    }))
                })

                marker._popup.on('close', () => {
                    marker.removeClassName('marker-active')

                    // on close, we set back the zoom to view the map
                    map.fitToMarkers({
                        center: [element.address.longitude, element.address.latitude],
                        zoom: 7.85,
                        speed: 2,
                        curve: 1
                    })

                    if (activelocation.id === element.id) {
                        dispatch(locationActions.setMapSelectedLocation({
                            id: 0,
                            scroll: false
                        }))
                    } 
                });

                markerRef.current = marker
            });

            mapRef.current.flyTo({ center: [foundLocations[0].address.longitude, foundLocations[0].address.latitude], zoom: 8 }); //zoom: 16 is good for a single location, zoom: 8 lets you see more locations....
        }
        
        


    }, [foundLocations]);


    useEffect(() => {
        mapRef.current.getMarkers().forEach(element => {
            element.removeClassName('marker-active')
            if (element.marker_id === activelocation.id) {
                element.addClassName('marker-active')
            }
        });
    }, [activelocation])
    

    return <div id="map" className={classes.map}></div>;
};

export default MapRadar;
